var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9331 23.0001V21.2668C22.9331 20.3474 22.5678 19.4656 21.9177 18.8155C21.2676 18.1654 20.3858 17.8001 19.4664 17.8001H12.5331C11.6137 17.8001 10.7319 18.1654 10.0818 18.8155C9.43164 19.4656 9.06641 20.3474 9.06641 21.2668V23.0001M19.4664 10.8668C19.4664 12.7814 17.9143 14.3335 15.9997 14.3335C14.0852 14.3335 12.5331 12.7814 12.5331 10.8668C12.5331 8.95223 14.0852 7.40015 15.9997 7.40015C17.9143 7.40015 19.4664 8.95223 19.4664 10.8668Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/userWhite.b914b9f687e8d29f86cf5d579be7de20.svg";
export { ForwardRef as ReactComponent };